import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getHomeLinkSuffix, slugify } from '../scripts/utils';
import Teams from './Teams';
import { makeTrackingCall } from '../scripts/tracking';
var COLUMN_THRESHOLD = 6;
var SubNavItem = function SubNavItem(_ref) {
  var item = _ref.item,
    navText = _ref.navText,
    navPosition = _ref.navPosition;
  var appears = item.appears,
    expires = item.expires,
    id = item.id,
    lang = item.lang,
    text = item.text,
    url = item.url;
  var classes = classnames({
    header__subnav__item: true,
    'header__subnav__item--home-link': item.text === navText
  });
  var handleClick = function handleClick(e) {
    var navPos = navPosition === 'side' ? 'Sidebar: ' : 'Topbar: ';
    var prop14 = "Navigation Module: ".concat(navPos).concat(navText, ": ").concat(text);
    makeTrackingCall(prop14);
    if (item.shouldOpenInNewWindow) {
      window.open(item.url);
      e.preventDefault();
    }
  };
  var appearanceDate = appears && appears * 1000;
  var expirationDate = expires && expires * 1000;
  // Timezones don't matter because time is given as unix timestamp
  var shouldAppear = appearanceDate ? Date.now() >= appearanceDate : true;
  var isItemExpired = expirationDate ? Date.now() >= expirationDate : false;
  return shouldAppear && !isItemExpired && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: classes,
    "data-nav-position": navPosition || 'top',
    "data-parent": navText,
    "data-sub-nav-name": text,
    href: url,
    key: id,
    lang: lang,
    onClick: handleClick
  }, item.text));
};
SubNavItem.propTypes = {
  item: PropTypes.object,
  navText: PropTypes.string,
  navPosition: PropTypes.string
};
var SubNav = function SubNav(_ref2) {
  var _ref2$subNavData = _ref2.subNavData,
    subNavData = _ref2$subNavData === void 0 ? [] : _ref2$subNavData,
    locale = _ref2.locale,
    parentNavItem = _ref2.parentNavItem,
    navPosition = _ref2.navPosition;
  var subNavContainer = useRef(null);
  var hasGroups = false;
  var isSideNav = navPosition && navPosition === 'side';
  var addColumns = subNavData && subNavData.length > COLUMN_THRESHOLD;
  var navText = parentNavItem && parentNavItem.text;
  var parentNavItemSuffixed = {};
  if (parentNavItem && isSideNav) {
    parentNavItemSuffixed = Object.assign({}, parentNavItem, {
      text: "".concat(parentNavItem.text, " ").concat(getHomeLinkSuffix(locale))
    });
  }
  if (parentNavItem && parentNavItem.subnavModule === 'teammodule') {
    return /*#__PURE__*/React.createElement(Teams, {
      parentNavItem: parentNavItemSuffixed,
      teamData: parentNavItem.teamData,
      navPosition: navPosition
    });
  }
  var subnavGroupItems = function subnavGroupItems(groupItems, groupIndex) {
    var groupItemsCopy = groupItems && groupItems.slice() || [];
    if (groupIndex === 0 && parentNavItemSuffixed.text) {
      groupItemsCopy.unshift(parentNavItemSuffixed);
    }
    if (groupItemsCopy.length) {
      hasGroups = true;
      return groupItemsCopy.map(function (subnavItem) {
        return !subnavItem.isHidden && /*#__PURE__*/React.createElement(SubNavItem, {
          key: "subnavitem-".concat(subnavItem.id),
          item: subnavItem,
          navText: navText,
          navPosition: navPosition
        });
      });
    }
    return;
  };
  var subnavMarkup = subNavData.map(function (item, index) {
    var groupItems = item.groupItems;
    if (groupItems) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        className: "header__subnav__group"
      }, item.title && /*#__PURE__*/React.createElement("span", {
        className: "header__subnav__group-title",
        id: item.title
      }, item.title), /*#__PURE__*/React.createElement("ul", {
        key: item.id,
        "aria-labelledby": item.title
      }, subnavGroupItems(groupItems, index)));
    } else {
      if (index === 0 && isSideNav && parentNavItemSuffixed.text) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: "fragment-".concat(item.id)
        }, /*#__PURE__*/React.createElement(SubNavItem, {
          key: "subnavitem-".concat(parentNavItemSuffixed.id),
          item: parentNavItemSuffixed,
          navText: navText,
          navPosition: navPosition
        }), !item.isHidden && /*#__PURE__*/React.createElement(SubNavItem, {
          key: "subnavitem-".concat(item.id),
          item: item,
          navText: navText,
          navPosition: navPosition
        }));
      } else {
        return !item.isHidden && /*#__PURE__*/React.createElement(SubNavItem, {
          key: "subnavitem-".concat(item.id),
          item: item,
          navText: navText,
          navPosition: navPosition
        });
      }
    }
  });
  var parentNavItemText = slugify((parentNavItem === null || parentNavItem === void 0 ? void 0 : parentNavItem.text) || '');
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": "".concat(parentNavItemText, " Subnav Flyout"),
    className: "header__subnav",
    ref: subNavContainer,
    "data-parent-nav-id": "nav-".concat(navPosition || 'top', "-item-").concat(parentNavItemText)
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__subnav__content"
  }, !hasGroups ? /*#__PURE__*/React.createElement("ul", {
    className: "header__subnav__group".concat(addColumns ? ' cols' : '')
  }, subnavMarkup) : subnavMarkup));
};
export default SubNav;
SubNav.propTypes = {
  subNavData: PropTypes.instanceOf(Array).isRequired,
  locale: PropTypes.string,
  parentNavItem: PropTypes.object,
  navPosition: PropTypes.string
};
SubNav.defaultProps = {
  subNavData: []
};